import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    TextField,
    TablePagination
} from '@mui/material';
import { getFirestore, collection, getDocs, query, orderBy } from 'firebase/firestore';
import { toast } from 'react-toastify';
import Takkevariheader from './Takkevariheader';

// Initialize Firestore
const db = getFirestore();

function Takkevarucsutreport() {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const fetchCustomers = async () => {
        setLoading(true);
        try {
            // Create a query to get all documents from the 'takkevaricusts' collection
            // Order the results by the 'createdAt' field in descending order
            const q = query(collection(db, 'takkevaricusts'), orderBy('name', 'asc'));
            const querySnapshot = await getDocs(q);

            const customersList = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));

            setCustomers(customersList);
            toast.success("Customers data fetched successfully!");
        } catch (error) {
            console.error("Error fetching customers: ", error);
            toast.error("Failed to fetch customers.");
        } finally {
            setLoading(false);
        }
    };

    // Fetch data when the component mounts
    useEffect(() => {
        fetchCustomers();
    }, []);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setPage(0); // Reset to the first page when searching
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredCustomers = customers.filter(customer =>
        customer.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (customer.mobile && customer.mobile.includes(searchQuery))
    );

    const paginatedCustomers = filteredCustomers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Box sx={{ p: { xs: 2, md: 4 } }}>
            <Takkevariheader />
            <Paper sx={{ p: { xs: 2, md: 4 }, borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, textAlign: 'center', color: '#1976d2', mb: 3 }}>
                    खातेदार Report
                </Typography>
                <TextField
                    label="Search by Name or Mobile"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    sx={{ mb: 3 }}
                />

                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                    <TableCell>#</TableCell>
                                    <TableCell>खातेदाराचे  नाव </TableCell>
                                    <TableCell>मोबाइल</TableCell>
                                    <TableCell>ई-मेल </TableCell>
                                    <TableCell>ऍड्रेस </TableCell>
                                    <TableCell>सिटी </TableCell>
                                    <TableCell>स्टेट </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedCustomers.length > 0 ? (
                                    paginatedCustomers.map((customer, index) => (
                                        <TableRow key={customer.id}>
                                            <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                            <TableCell>{customer.name}</TableCell>
                                            <TableCell>{customer.mobile}</TableCell>
                                            <TableCell>{customer.email}</TableCell>
                                            <TableCell>{customer.address}</TableCell>
                                            <TableCell>{customer.city}</TableCell>
                                            <TableCell>{customer.state}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            No customers found.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={filteredCustomers.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    );
}

export default Takkevarucsutreport;